import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa6';
import Header from '../Headers/header';
import './PrivacyPolicy.css';

export default function PrivacyPolicy() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const isRTL = i18n.dir(i18n.language) === 'rtl';
    const sections = t('privacy.sections', { returnObjects: true });

    return (
        <div className="privacy-page">
            <Header />
            <div className="privacy-container">
                <button className="privacy-back-btn" onClick={() => navigate(-1)}>
                    {isRTL ? <FaArrowRight /> : <FaArrowLeft />}
                    {t('privacy.back')}
                </button>

                <div className="privacy-body">
                    <h1 className="privacy-title">{t('privacy.title')}</h1>
                    <p className="privacy-updated">{t('privacy.lastUpdated')}</p>

                    <p className="privacy-intro">{t('privacy.intro')}</p>

                    <hr className="privacy-divider" />

                    {Array.isArray(sections) && sections.map((section, index) => (
                        <div key={index} className="privacy-section">
                            <h2>{section.title}</h2>
                            <p>{section.content}</p>
                        </div>
                    ))}

                    <hr className="privacy-divider" />

                    <div className="privacy-contact">
                        <h2>{t('privacy.contactTitle')}</h2>
                        <p>{t('privacy.contactText')}</p>
                        <a href="mailto:contact@ghaythapp.com">contact@ghaythapp.com</a>
                    </div>
                </div>
            </div>
        </div>
    );
}
